import keymirror from 'keymirror';
import { request } from 'js/api/axios';
import { callApi } from '../api';
import { spreadApiKeys, extractApiKeys } from '../utils';
import { SCHEMAS } from 'js/api/schemas';

export const types = keymirror({
  ...spreadApiKeys('LOAD_USER_GROUP_STATS'),
});

export function listUserGroupStats(workspaceId, queryId = null) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.LOAD_USER_GROUP_STATS, types),
        request: (_data, token) =>
          request.get(`/api/workspaces/${workspaceId}/user-group-stats`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }),
        schema: SCHEMAS.USER_GROUP_STAT_ARRAY,
        meta: { queryId },
      },
      dispatch
    );
  };
}
